import mobileNavOpen from './mobile_nav_open';
import navigationPosition from './navigation_position';
import navigationSearchOpen from './navigation_search_open';
import navigationSearchEnabler from './navigation_search_enabler';
import openToggle from './open_toggle';
import navigationDataLayer from './navigation_data_layer';

(() => {
  mobileNavOpen();
  // navigationPosition();
  openToggle();
  navigationSearchOpen();
  navigationSearchEnabler();
  navigationDataLayer();
})();
